import { getPageKey } from '@/tracks/getPageKey';
import { getCookie } from '../cookie';
import Constants from '@/constants/const';
import { getUrlObject } from '../getUrlObject';
import { isSayWeeeApp } from '@/utils/common/device';
import { isLatinoChannel } from '@/utils/common/latino-app';
import { compose } from '../compose';
import * as eventsPipelineFns from './components/events-pipeline';
import { CMS_PAGE_CTX } from '@/constants/campaigns';
import { extractUtmItmParams, getLastURLParam } from '../url';

const interceptors = [
  {
    page_key: 'mweb_product',
    interceptor: ({ params, pageContext }, next) => {
      let pageUrl = /^http/.test(pageContext.page_url) ? pageContext.page_url : '';
      let _url = new URL(pageUrl || window.location.href);
      next({
        ...params,
        ctx: {
          ...params.ctx,
          page_target: _url.pathname.split('/').pop()
        }
      });
    }
  },
  {
    page_key: 'mweb_mkpl_seller',
    interceptor: ({ params, pageContext }, next) => {
      let pageUrl = /^http/.test(pageContext.page_url) ? pageContext.page_url : '';
      let _url = new URL(pageUrl || window.location.href);
      next({
        ...params,
        ctx: {
          ...params.ctx,
          page_target: _url.pathname.split('/').pop()
        }
      });
    }
  },
  {
    page_key: 'mweb_collection',
    interceptor: ({ params, pageContext }, next) => {
      let _url = getUrlObject(pageContext.page_url || window.location.href);
      next({
        ...params,
        source: _url?.query?.ws ?? '',
        ctx: {
          ...params.ctx,
          page_target: _url?.pathname?.split('/')?.pop()
        }
      });
    }
  },
  {
    page_key: 'mweb_sayweee_collection',
    interceptor: ({ params, pageContext }, next) => {
      let _url = getUrlObject(pageContext.page_url || window.location.href);
      next({
        ...params,
        source: _url?.query?.ws ?? '',
        ctx: {
          ...params.ctx,
          page_target: _url?.pathname?.split('/')?.pop()
        }
      });
    }
  },
  {
    page_key: 'mweb_search_result',
    interceptor: ({ params, pageContext }, next) => {
      let pageUrl = /^http/.test(pageContext.page_url) ? pageContext.page_url : '';
      let _url = new URLSearchParams((pageUrl || window.location.href).split('?').pop());
      next({
        ...params,
        ctx: {
          ...params.ctx,
          default_keyword: !_url.get('trigger_type') ? _url.get('keyword') : void 0,
          page_target: _url.get('keyword')
        }
      });
    }
  },
  {
    //这个页面不发送pv
    page_key: 'mweb_event_landing',
    interceptor: ({ params, pageContext }, next) => {
      let pageUrl = /^http/.test(pageContext.page_url) ? pageContext.page_url : '';
      let _url = new URL(pageUrl || window.location.href);
      if (_url.pathname.split('/').pop() === 'center') {
        return;
      }
      next(params);
    }
  },
  {
    // /support开头的不发pv
    matcher: _pageContext => {
      return window.location.pathname.includes('/support/');
    },
    interceptor: () => {
      return;
    }
  },
  {
    page_key: 'mweb_brand',
    interceptor: ({ params, pageContext }, next) => {
      let pageUrl = /^http/.test(pageContext.page_url) ? pageContext.page_url : '';
      let _url = new URL(pageUrl || window.location.href);
      next({
        ...params,
        ctx: {
          ...params.ctx,
          page_target: _url.pathname.split('/').pop()
        }
      });
    }
  },
  {
    page_key: 'mweb_order_detail',
    interceptor: ({ params, pageContext }, next) => {
      let pageUrl = /^http/.test(pageContext.page_url) ? pageContext.page_url : '';
      let _url = new URL(pageUrl || window.location.href);
      next({
        ...params,
        ctx: {
          ...params.ctx,
          page_target: _url.pathname.split('/').pop()
        }
      });
    }
  },
  {
    page_key: 'mweb_share_list_detail',
    interceptor: ({ params, pageContext }, next) => {
      let pageUrl = /^http/.test(pageContext.page_url) ? pageContext.page_url : '';
      let _url = new URL(pageUrl || window.location.href);
      next({
        ...params,
        ctx: {
          ...params.ctx,
          page_target: _url.pathname.split('/').pop()
        }
      });
    }
  },
  {
    page_key: 'mweb_share_list_landing',
    interceptor: ({ params, pageContext }, next) => {
      let pageUrl = /^http/.test(pageContext.page_url) ? pageContext.page_url : '';
      let _url = new URL(pageUrl || window.location.href);
      next({
        ...params,
        ctx: {
          ...params.ctx,
          page_target: _url.pathname.split('/').pop()
        }
      });
    }
  },
  // cms活动的页面source定制
  {
    matcher: _pageContext => {
      return window.location.pathname.includes('/cms/page/');
    },
    interceptor: ({ params, pageContext }, next) => {
      let pageUrl = /^http/.test(pageContext.page_url) ? pageContext.page_url : '';
      let _url = new URL(pageUrl || window.location.href);
      let urlParams = _url.pathname.split('/');
      let key = urlParams.pop();
      let type = urlParams.pop();
      if (params?.meta_info !== void 0) {
        next({
          ...params,
          source: `${type}_${key}`
        });
      }
    }
  },
  {
    page_key: 'mweb_help_view',
    interceptor: ({ params, pageContext }, next) => {
      let pageUrl = /^http/.test(pageContext.page_url) ? pageContext.page_url : '';
      let _url = new URL(pageUrl || window.location.href);
      next({
        ...params,
        ctx: {
          ...params.ctx,
          page_target: _url.pathname.split('/').pop()
        }
      });
    }
  },
  {
    page_key: 'mweb_help_detail',
    interceptor: ({ params, pageContext }, next) => {
      let pageUrl = /^http/.test(pageContext.page_url) ? pageContext.page_url : '';
      let _url = new URL(pageUrl || window.location.href);
      next({
        ...params,
        ctx: {
          ...params.ctx,
          page_target: _url.pathname.split('/').pop()
        }
      });
    }
  },
  {
    matcher: _pageContext => {
      return window.location.pathname.includes('/order/success/v2/');
    },
    interceptor: ({ params, pageContext }, next) => {
      next({
        ...params,
        ctx: {
          ...params.ctx,
          page_target:
            window['__NEXT_DATA__'].props.pageProps.orderData?.order_infos?.[0]?.sub_order_type === 'addon'
              ? 'add_on_order'
              : null
        }
      });
    }
  },
  {
    page_key: 'mweb_promotion_landing',
    interceptor: ({ params, pageContext }, next) => {
      let pageUrl = /^http/.test(pageContext.page_url) ? pageContext.page_url : '';
      let _url = new URL(pageUrl || window.location.href);
      next({
        ...params,
        ctx: {
          ...params.ctx,
          page_target: _url.searchParams.get('ps_id')
        }
      });
    }
  },
  {
    page_key: 'mweb_gift_card_landing',
    interceptor: ({ params, pageContext }, next) => {
      const count = window['__NEXT_DATA__'].props.pageProps.landingInfo?.cards?.length;
      next({
        ...params,
        ctx: {
          ...params.ctx,
          page_cnt: count
        }
      });
    }
  },
  {
    page_key: 'mweb_annual_report',
    interceptor: () => {
      return;
    }
  },
  {
    page_key: 'mweb_annual_report_2025',
    interceptor: () => {
      return;
    }
  }
];

const CUSTOM_BEFORE_INTERCEPTORS: {
  page_key?: string;
  customPV?: boolean;
  matcher?: (pageContext: any) => boolean;
  interceptor: (event: any) => void;
}[] = [
  {
    customPV: true,
    matcher: ({ pageContext }) => {
      return (pageContext?.page_url || location.pathname)?.includes('/cms/page/');
    },
    interceptor: (event: any) => {
      event.page_ctx_app = event.params.page_ctx_app || {};
      const metaInfo = event.params.meta_info ?? (window as any)[CMS_PAGE_CTX]?.meta_info ?? '';
      if (metaInfo) {
        event.page_ctx_app.meta_info = metaInfo;
      }
      event.page_ctx_app.page_target = event.params.page_target ?? (window as any)[CMS_PAGE_CTX]?.page_target ?? '';
      ['meta_info', 'page_target', 'page_key'].forEach(key => {
        if (event.params[key]) {
          delete event.params[key];
        }
      });
    }
  }
];

const createWeeeTracker = async () => {
  const { Fingerprint, DEVICE_ID_V2, SIGNATURE_TOKEN } = await import('@weee-fe/core');
  const finger = new Fingerprint();
  const finalData = finger.getData();
  if (!isSayWeeeApp() && !finalData?.[DEVICE_ID_V2]) {
    const d2 = getCookie(DEVICE_ID_V2);
    const st = finger.createEncrptFingerprint(d2);
    finalData[DEVICE_ID_V2] = d2;
    finalData[SIGNATURE_TOKEN] = st;
  }
  const isLatino = isLatinoChannel();
  if (!window.WeeeTracker) return;
  let lastPvInfo = {
    pathname: '',
    pageKey: ''
  };
  let tracker = new window.WeeeTracker({
    baseUrl: process.env.NEXT_PUBLIC_TRACKER_API,
    maxCacheLen: 6,
    maxWaitingTime: 3000,
    getPageKey: getPageKey,
    isAppFn: isSayWeeeApp,
    getBaseParams() {
      const data = finalData || {};
      return {
        user_agent: window?.navigator?.userAgent || '',
        ...(isLatino ? { bu: 'latino' } : {}),
        ...data
      };
    }
  });
  window._weeeTracker = tracker;

  const oldOnBeforeHandleEvent = window._weeeTracker.onBeforeHandleEvent;
  window._weeeTracker.onBeforeHandleEvent = function (events: any[]) {
    // 提前返回：如果没有事件，直接返回
    if (!events || events.length === 0) {
      return oldOnBeforeHandleEvent.call(this, events);
    }

    // 缓存重复的计算和检查（提取到循环外）
    const pathname = location.pathname;
    const isSearchPage = pathname.includes('/search');
    const isProductPage = pathname.includes('/product');
    const isCmsPage = pathname.includes('/cms/page/');
    const locationHref = window?.location?.href ?? '';

    // trace_id 处理 - 优化：只在需要时获取
    let traceId = '';
    if (isSearchPage) {
      traceId = window.localStorage?.getItem('trace_id') ?? '';
    } else if (isProductPage) {
      traceId = getLastURLParam(locationHref, 'trace_id');
    }

    // 提取 UTM/ITM 参数（只调用一次）
    const utmItmParams = extractUtmItmParams(locationHref);
    const hasUtmItmParams = Object.keys(utmItmParams).length > 0;

    // 缓存页面上下文和拦截器匹配结果
    const pageContext = window._weeeTracker?.pageContext || {};
    const matchedInterceptors = CUSTOM_BEFORE_INTERCEPTORS.filter(interceptor => interceptor.matcher?.(pageContext));

    // 缓存 CMS 页面上下文（如果是 CMS 页面）
    let cmsPageCtx: any = null;
    let cmsPageCtxApp: any = null;
    if (isCmsPage) {
      cmsPageCtx = (window as any)[CMS_PAGE_CTX];
      if (cmsPageCtx && hasUtmItmParams) {
        cmsPageCtxApp = { ...cmsPageCtx, ...utmItmParams };
      }
    }

    // 缓存 product 页面需要的数据
    let previousPageCtxAppP: any = null;
    if (isProductPage) {
      const previousPageCtxApp = window._weeeTracker?.getRefererPageCtxApp();
      previousPageCtxAppP = previousPageCtxApp?._p_ || null;
    }

    // 主循环：遍历事件
    for (const event of events) {
      const eventType = event.type;

      // 处理 trace_id（只对非 page_view 事件）
      if (traceId && eventType !== 'page_view') {
        event.params = event.params || {};
        event.params.ctx = event.params.ctx || {};
        event.params.ctx.trace_id = traceId;
      }

      // 处理 page_view 事件
      if (eventType === 'page_view') {
        if (isCmsPage) {
          if (cmsPageCtx && window._weeeTracker?.setPageCtxApp) {
            // 使用缓存的 pageCtxApp
            window._weeeTracker.setPageCtxApp(cmsPageCtxApp || cmsPageCtx, false);
          }
        } else if (hasUtmItmParams && window._weeeTracker?.setPageCtxApp) {
          window._weeeTracker.setPageCtxApp(utmItmParams, true);
        }
      }

      // 应用匹配的拦截器（只遍历匹配的）
      if (matchedInterceptors.length > 0) {
        for (const interceptor of matchedInterceptors) {
          interceptor.interceptor(event);
        }
      }

      // 添加 UTM/ITM 参数到 page_ctx_app
      if (hasUtmItmParams) {
        event.page_ctx_app = event.page_ctx_app ? { ...event.page_ctx_app, ...utmItmParams } : utmItmParams;
      }

      // 处理 product 页面的 _p_ 数据
      if (isProductPage && previousPageCtxAppP) {
        event.page_ctx_app = event.page_ctx_app
          ? { ...event.page_ctx_app, ...previousPageCtxAppP }
          : previousPageCtxAppP;
      }
    }

    // 执行 pipeline 函数
    const executer = compose(...Object.values(eventsPipelineFns));
    const newEvents = executer(events);
    // eslint-disable-next-line
    return oldOnBeforeHandleEvent.call(this, newEvents);
  };

  window._weeeTracker.customPv = ({ params, pageContext }, next) => {
    const currentPathname = new URL(pageContext.page_url as string).pathname;
    const customPV =
      CUSTOM_BEFORE_INTERCEPTORS.find(interceptor => interceptor.matcher?.(pageContext))?.customPV ?? false;

    // 检查是否重复PV上报
    const isDuplicatePV =
      lastPvInfo.pathname === currentPathname && lastPvInfo.pageKey === pageContext.page_key && !customPV;

    if (isDuplicatePV && !isSayWeeeApp()) {
      console.log('重复的PV上报被过滤:', {
        url: pageContext.page_url,
        pageKey: pageContext.page_key
      });
      return true;
    }

    // 更新lastPvInfo
    lastPvInfo = {
      pathname: currentPathname,
      pageKey: pageContext.page_key
    };
    let index = interceptors.findIndex(item => {
      if (item.matcher) {
        return item.matcher?.(pageContext);
      }
      return item.page_key === pageContext?.page_key;
    });
    if (index < 0) {
      next(params);
    } else {
      interceptors[index].interceptor({ params, pageContext }, next);
    }
  };
  window.dispatchEvent(new Event('weeeTrackerLoaded'));
};

export const initWeeeTracker = async () => {
  //从cookie中获取 zipcode, 如果不存在需要等待订阅监听 userPreOrderLogged 的状态
  const zipcode = getCookie(Constants.ZIP_CODE);
  if (zipcode) {
    createWeeeTracker();
  } else {
    window.addEventListener('userPreOrderLogged', () => {
      createWeeeTracker();
    });
  }
};
